import React, { useEffect } from 'react';
import InfiniteScroll, { Props as InfiniteScrollProps } from 'react-infinite-scroll-component';
import { useTranslate } from '@tolgee/react';
import api from '@/api/services/achievements';
import { Typography } from '@/components/Atoms';
import CustomSkeleton from '@/components/Common/CustomSkeleton';
import LoadingBalls from '@/components/Common/LoadingBalls';
import { ITaskDataType } from '@/types/Achievements';
import TaskCenterCardList2 from './_taskCardList2';
import { useStore } from '@/zustand/store/store';

export type AchievementListWihtLoadingProps = {
  items: ITaskDataType[];
  loaderActive?: boolean;
  role?: boolean;
  isLoading: boolean;
  mutate: () => void;
} & Pick<InfiniteScrollProps, 'next' | 'hasMore'>;

const AchievementListWihtLoading = ({ items, mutate, role, isLoading, loaderActive, ...props }: AchievementListWihtLoadingProps) => {
  const { t } = useTranslate('commandCenter');
  const {
    commandSocketData: { stateChanged },
  } = useStore();

  useEffect(() => {
    if (stateChanged) {
      mutate();
    }
  }, [stateChanged]);

  // Telegram Auth
  /* **************** */
  useEffect(() => {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.hash.substring(1));
    const tgAuthResult = params.get('tgAuthResult');

    if (tgAuthResult) {
      const jsonPayload = atob(tgAuthResult);
      const data = JSON.parse(jsonPayload);

      api
        .verifyOtherAccount('telegram', { user_id: `${data.id}` }, 'command_center')
        .then(() => {
          mutate();
        })
        .catch((error) => {
          console.error('Error verifying account:', error);
        });
    }
  }, []);

  return (
    <>
      <InfiniteScroll
        dataLength={items?.length}
        {...props}
        loader={
          loaderActive && (
            <div className='mb-3 mt-7'>
              <LoadingBalls />
            </div>
          )
        }
      >
        {items && <TaskCenterCardList2 key={role.toString()} role={role} items={items} />}
      </InfiniteScroll>
      {isLoading && (
        <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-2 mx-auto place-items-center md:place-items-stretch overflow-hidden py-3 px-1'>
          {Array(6)
            .fill('')
            .map((item, index) => (
              <CustomSkeleton key={index} visible={true} className={'flex rounded-lg'}>
                <div className='min-h-[300px] w-[260px] '></div>
              </CustomSkeleton>
            ))}
        </div>
      )}

      {!isLoading && !items?.length && (
        <>
          {role ? (
            <div className='text-white font-bold text-center mt-14 mb-8'>
              <Typography size='s16ToS14'>{t('CENTER_SECTION.achievementSection.activeCommander.description')}</Typography>
            </div>
          ) : (
            <div className='text-white font-bold text-center mt-14 mb-8'>
              <Typography size='s16ToS14'>{t('CENTER_SECTION.achievementSection.commanderData.searchFailed')}</Typography>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default AchievementListWihtLoading;
